import { render, staticRenderFns } from "./LoginForm.ts.vue?vue&type=template&id=520b8bbe"
import script from "./LoginForm.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginForm.ts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LoginForm.ts.vue?vue&type=style&index=0&id=520b8bbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports